export default "__VITE_ASSET__lnPy2Nd$__"